import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { mediaAlt, refreshExpiredMedia, type Message } from "./messages.ts";

/**
 * Не чаще раза в минуту: если часы телефона спешат, свежая ссылка тоже кажется истёкшей,
 * и без паузы недоступное хранилище гоняло бы перезапросы по кругу.
 */
const REFRESH_INTERVAL_MS = 60_000;

type MessageImageProps = { message: Message; className?: string; loading?: "lazy" | "eager" };

/** Derivative сообщения по подписанной ссылке; истёкшая ссылка заменяется свежей перезапросом сообщения. */
export function MessageImage({ message, className, loading }: MessageImageProps) {
  const queryClient = useQueryClient();
  const lastRefresh = useRef(-Infinity);
  if (!message.mediaUrl) return null;

  function recover() {
    const now = Date.now();
    if (now - lastRefresh.current < REFRESH_INTERVAL_MS) return;
    if (refreshExpiredMedia(queryClient, message, now)) lastRefresh.current = now;
  }

  return <img className={className} src={message.mediaUrl} alt={mediaAlt(message)} loading={loading} onError={recover} />;
}
